import React from 'react'
import ModalConfirmacionContacto from './ModalConfirmacionContacto'
import ModalVerificacion from './ModalVerificacion'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import {gu_cu_ShowModalConfirmar} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import ModalUserCreated from './ModalUserCreated'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'

const ModalsControls = () => {
  const {activoConfirmacion, activoVerificacion, activoConfirmar, activoCreado} = useSelector(
    (state: State) => state.gestionUsuario.creacionUsuario.modals
  )
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)
  const sucursales = useSelector(
    (state: State) => state.gestionUsuario.creacionUsuario.sucursalesAsignadas
  )

  const closeModalConfirm = async () => {
    await dispatch(gu_cu_ShowModalConfirmar(false))
  }

  return (
    <>
      {activoConfirmacion && <ModalConfirmacionContacto />}
      {activoVerificacion && <ModalVerificacion />}

      {activoConfirmar && (
        <ModalConfirm
          title={'Confirmar nuevo usuario'}
          detail={
            sucursales.length === 0
              ? 'Estás a punto de crear un nuevo usuario sin asociarle ninguna sucursal ¿Deseas continuar?'
              : 'Estás a punto de crear un nuevo usuario, ¿Deseas continuar?'
          }
          actionConfirm={actions.gu_cu_ConfirmarCreaciónDeUsuario}
          closeModalConfirm={closeModalConfirm}
          Styles={{maxWidth: '500px'}}
        />
      )}
      {activoCreado && <ModalUserCreated />}
    </>
  )
}

export default ModalsControls
